<template>
    <div class="conteiner">
        <div v-if="vista === 'home'">
            <formgroup label="" :validator="$v.textBusqueda">
                <input class="form-control" type="text" v-model="textBusqueda" placeholder="Buscar Etiquetas..." />
            </formgroup>
            <div class="mx-1 my-3">
                <div class="d-flex justify-content-between align-items-center">
                    <h6 class="m-0">Etiquetas</h6>
                    <button v-if="esEtiquetaAdmin" type="button" class="btn btn-sm mx-1 config" title="Editar etiquetas"
                        @click="cambiarVista('lista', 'crear')">
                        <i class="bi bi-pencil" style="font-size: medium;"></i>
                    </button>
                </div>
                <div class="my-3">
                    <div class="form-check my-1 d-flex justify-content-center" v-for="etiqueta in etiquetasFiltradas"
                        :key="etiqueta.idEtiqueta">
                        <input class="form-check-input me-2" type="checkbox" value=""
                            :id="'checkEtiqueta' + etiqueta.idEtiqueta" :checked="isChecked(etiqueta.idEtiqueta)"
                            @change="toggleEtiqueta(etiqueta)">
                        <span class="badge etiquetas me-2 centrado" :style="{ backgroundColor: etiqueta.color }"
                            for="btn-check" style="cursor: pointer;">{{ etiqueta.nombre
                            }}</span>
                    </div>
                </div>
                <div class="mt-4 mx-4">
                    <button type="button" class="btn btn-sm btn-primary mx-1 w-100" title="Etiqueta nueva"
                        @click="guardarEtiquetas()">
                        Guardar
                    </button>
                </div>
            </div>
        </div>
        <div v-if="vista === 'lista'">
            <formgroup label="" :validator="$v.textBusqueda">
                <input class="form-control" type="text" v-model="textBusqueda" placeholder="Buscar Etiquetas..." />
            </formgroup>
            <div class="mx-1 my-3">
                <h6 class="text-align-center">Etiquetas</h6>
                <div class="my-3">
                    <div class="form-check my-1 d-flex justify-content-center" v-for="etiqueta in etiquetasFiltradas"
                        :key="etiqueta.idEtiqueta">
                        <span class="badge etiquetas me-2 centrado" :style="{ backgroundColor: etiqueta.color }"
                            for="btn-check" style="cursor: pointer;">{{ etiqueta.nombre
                            }}</span>
                        <button type="button" class="btn btn-sm btn-light" title="Editar"
                            @click="editarEtiqueta(etiqueta)">
                            <i class="bi bi-pencil"></i>
                        </button>
                    </div>
                </div>
                <div class="mt-4 mx-4">
                    <button type="button" class="btn btn-sm btn-primary w-100" title="Etiqueta nueva"
                        @click="cambiarVista('abm', 'crear')">
                        Crear una etiqueta nueva
                    </button>
                </div>
            </div>
        </div>
        <div v-if="vista === 'abm'">
            <div class="d-flex justify-content-center">
                <button class="btn btnDemo d-flex align-items-center"
                    :style="{ backgroundColor: this.etiquetaABM.color || 'gray' }">{{ this.etiquetaABM.nombre
                    }}</button>
            </div>
            <formgroup label="Título" :validator="$v.etiquetaABM.nombre">
                <input class="form-control" type="text" v-model="etiquetaABM.nombre" />
            </formgroup>
            <div class="mt-4">
                <button v-for="color in coloresEtiqueta" :key="color.id" class="btn coloresEtiq"
                    :style="{ backgroundColor: color.colorCode, }"
                    :class="{ seleccionado: etiquetaABM.color === color.colorCode }"
                    @click="seleccionarColor(color.colorCode)">
                </button>
            </div>
            <div class="mt-4 mx-4">
                <button type="button" class="btn btn-sm btn-outline-secondary w-100 mb-3" title="Quitar Color"
                    @click="quitarSeleccionColor()">
                    Quitar Color
                </button>
                <div v-if="modo === 'crear'" class="mb-2">
                    <button type="button" class="btn btn-sm btn-primary w-100" title="Crear Etiqueta"
                        @click="crearEtiqueta()">
                        Crear Etiqueta
                    </button>
                </div>
                <div v-else class="mb-2 d-flex justify-content-between">
                    <button type="button" class="btn btn-sm btn-primary" title="Guardar Etiqueta"
                        @click="modificarEtiqueta()">
                        Guardar Cambios
                    </button>
                    <button type="button" class="btn btn-sm btn-danger" title="Eliminar Etiqueta"
                        @click="eliminarEtiqueta()">
                        Eliminar Etiqueta
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { showSuccess, showError } from "@justiciacordoba/js-messages";
import { formgroup } from "@justiciacordoba/vue-formgroup";
import { required } from "vuelidate/lib/validators";
import { coloresEtiqueta } from "../../assets/tagColors";
import axios from "axios";

export default {
    name: "EtiquetasDocumento",
    components: {
        formgroup
    },
    props: {
        vista: {
            type: String,
            required: true,
        },
        ticket: {
            type: Object,
            required: true
        },
        etiquetasDoc: Array
    },
    data() {
        return {
            etiquetas: [],
            coloresEtiqueta: coloresEtiqueta,
            textBusqueda: '',
            etiquetaIsChecked: false,
            etiquetaABM: {
                idEtiqueta: '',
                nombre: '',
                color: null
            },
            etiquetaSeleccionada: null,
            modo: 'crear',
            etiquetasDocLocal: [...this.etiquetasDoc]
        }
    },
    validations: {
        textBusqueda: {},
        etiquetaABM: {
            nombre: { required },
            color: { required }
        }
    },
    computed: {
        esEtiquetaAdmin() {
            return this.$store.getters.esEtiquetaAdmin
        },
        etiquetasFiltradas() {
            return this.etiquetas.filter(etiqueta => {
                return etiqueta.nombre.toLowerCase().includes(this.textBusqueda.toLowerCase())
            })
        },
        etiquetasSeleccionadas() {
            // return this.etiquetasDocLocal.map(etiqueta => etiqueta.id || etiqueta.idEtiqueta);            
            const et = this.etiquetasDocLocal.map(etiqueta => etiqueta.id || etiqueta.idEtiqueta);
            return et
        }
    },
    methods: {
        handleTagCheck() {
            this.etiquetaIsChecked = !this.etiquetaIsChecked;
        },
        buscarEtiquetas() {
            const body = { paginaIndice: 0, paginaRegistros: 40 }
            axios.post('/api/Etiquetas/Buscar', body)
                .then((response) => {
                    if (response.data) {
                        this.etiquetas = response.data
                    }
                })
                .catch((error) => {
                    showError(error)
                })
        },
        cambiarVista(vista, modo) {
            if (vista === 'abm' && modo === 'crear') {
                this.etiquetaABM = { idEtiqueta: '', titulo: '', color: null };
                this.modo = 'crear'
            }
            this.$emit("update:title", vista === "lista" ? "Etiquetas" : (modo === 'crear' ? 'Crear Etiqueta' : 'Editar Etiqueta'));
            this.$emit("update:vista", vista);
        },
        seleccionarColor(color) {
            this.etiquetaABM.color = color;

        },
        quitarSeleccionColor() {
            this.etiquetaABM.color = null;
        },
        crearEtiqueta() {
            const mensajeValidacion = 'El nombre de la etiqueta y el color son requeridos.';
            this.$v.etiquetaABM.$touch();
            if (this.$v.etiquetaABM.$invalid) {
                showError(mensajeValidacion);
                return;
            }

            const body = { nombre: this.etiquetaABM.nombre, color: this.etiquetaABM.color }
            axios.post('/api/Etiquetas/Crear', body)
                .then((response) => {
                    if (response) {
                        showSuccess("Se creó la etiqueta correctamente.");
                        this.cambiarVista('lista', '');
                        this.buscarEtiquetas();
                    }
                })
                .catch(() => {
                    showError(mensajeValidacion)
                })
        },
        modificarEtiqueta() {
            const body = { idEtiqueta: { value: this.etiquetaABM.idEtiqueta }, nombre: this.etiquetaABM.nombre, color: this.etiquetaABM.color }
            axios.post('/api/Etiquetas/Modificar', body)
                .then((response) => {
                    if (response) {
                        showSuccess("Se modificó la etiqueta correctamente.");
                        this.cambiarVista('lista', '');
                        this.buscarEtiquetas();
                    }
                })
                .catch((error) => {
                    showError(error)
                })
        },
        editarEtiqueta(etiqueta) {
            this.etiquetaABM.nombre = etiqueta.nombre;
            this.etiquetaABM.color = etiqueta.color;
            this.etiquetaABM.idEtiqueta = etiqueta.idEtiqueta;
            this.modo = 'editar'
            this.cambiarVista('abm', this.modo);
        },
        eliminarEtiqueta() {
            const body = { idEtiqueta: { value: this.etiquetaABM.idEtiqueta } }
            axios.post('/api/Etiquetas/Eliminar', body)
                .then((res) => {
                    if (res) {
                        showSuccess('Se eliminó la etiqueta.')
                        this.cambiarVista('lista', '');
                        this.buscarEtiquetas();
                    }
                })
                .catch((error) => showError(error))
        },
        isChecked(idEtiqueta) {
            const checkeados = this.etiquetasSeleccionadas.includes(idEtiqueta.toString());
            return checkeados
        },
        toggleEtiqueta(etiqueta) {
            const idEtiqueta = etiqueta.id || etiqueta.idEtiqueta;
            if (this.etiquetasSeleccionadas.includes(idEtiqueta)) {
                this.etiquetasDocLocal = this.etiquetasDocLocal.filter(e => (e.id || e.idEtiqueta) !== idEtiqueta);
            } else {
                this.etiquetasDocLocal.push(etiqueta);
            }
        },
        async guardarEtiquetas() {
            const idEtiquetasArray = this.etiquetasSeleccionadas.map(id => ({ value: Number(id) }));

            const body = { idEtiquetas: idEtiquetasArray, nombreObjeto: 'ticket', codigoObjeto: this.ticket.id }
            try {
                await axios.post('/api/Etiquetas/ObjetoAplicar', body)
                    .then((res) => {
                        if (res) {
                            this.etiquetasDocLocal = this.etiquetas.filter(etiqueta =>
                                this.etiquetasSeleccionadas.includes(etiqueta.id || etiqueta.idEtiqueta)
                            );
                        }
                        // showSuccess("Se actualizaron las etiquetas correctamente.")
                        this.$emit('closeModal');
                    })
                    .catch((error) => showError(error))

                this.$emit('update-etiquetas', this.etiquetasDocLocal);

            } catch (error) {
                console.error("Error al cambiar el estado del checkbox:", error);
            }
        }
    },
    mounted() {
        this.buscarEtiquetas();
    }
}
</script>

<style>
.etiquetas {
    height: 35px;
    width: 255px;
}

.centrado {
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.btnVolver {
    text-decoration: none;
}

.coloresEtiq {
    margin: 5px;
    color: '#fff';
    width: 63px;
    height: 32px;
    border: none;
    border-radius: 0;
    position: relative;
}

.coloresEtiq:hover {
    filter: brightness(1.2);
}

.seleccionado {
    box-shadow: 0 0 0 3px white, 0 0 0 5px rgb(135, 134, 134);
}

.btnDemo {
    width: 12em;
    height: 2em;
    color: white !important;
}

.config {
    background-color: lavender!important;
}

.config:hover {
    background-color: #cfcfcf!important;
}
</style>